import script from "./ButtonDarkBorder.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonDarkBorder.vue?vue&type=script&setup=true&lang=js"

import "./ButtonDarkBorder.vue?vue&type=style&index=0&id=d6a7a1e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6a7a1e2"]])

export default __exports__